import React from 'react';
import { observer } from 'mobx-react';

import { AntSelectProps } from 'controls/react/ant/antSelect';

import { legendOptions } from './constants';
import { AntSelectWithCustomOptions } from 'controls/react/AntSelectWithCustomOptions';

export type LegendSelectProps = AntSelectProps<string[]> & {};

export const MetricLegendSelect = observer((props: LegendSelectProps) => {
	return <AntSelectWithCustomOptions {...props} options={legendOptions} />;
});
